import axios from 'plugins/axios';

const baiduApi = {
    getBillList(params: GetBillListParams): Promise<{listData: any[], count: number}> {
        return axios.post('/gpbusiness/baidu/getBillList', params);
    },
    setConfirm(params: SetConfirmParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/setConfirm', params);
    },
    getConfirmNum(): Promise<{count: number}> {
        return axios.post('/gpbusiness/baidu/getConfirmNum');
    },
    getBillDownload(params: DownloadBill): void {
        const url = new URL('/gpbusiness/baidu/getBillDownload', window.location.href);
        url.search = (new URLSearchParams(params as URLSearchParams)).toString();
        window.location.href = url && url.toString();
    },
    getBalanceMoney(): Promise<GetBanlanceMoney> {
        return axios.post('/gpbusiness/baidu/getBalanceMoney');
    },
    setWithdrawBill(): Promise<any> {
        return axios.post('/gpbusiness/baidu/setWithdrawBill');
    },
    getInvoiceDetail(params: {id: string}): Promise<any> {
        return axios.post('/gpbusiness/invoice/getInvoiceDetail', params);
    },
    setInvoice(params: SetInvoiceParams): Promise<any> {
        return axios.post('/gpbusiness/invoice/setInvoice', params);
    },
    uploadInvoice(params: any): Promise<any> {
        return axios.post('/gpbusiness/invoice/upload', params);
    },
    // 提交数电发票
    setElecInvoice(params: SetInvoiceParams): Promise<any> {
        return axios.post('/gpbusiness/invoice/setInvoiceNew', params);
    },
    // 获取是否开数电发票模块标识
    getInvoiceSwitch(): Promise<any> {
        return axios.post('/gpbusiness/switch/get');
    },
    getBiDetail(params: GetBiDetailParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/getBillDetail', params);
    },
    setQuestion(params: SetQuestionParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/setQuestion', params);
    },
    cancelQuestion(params: CancelQuestionParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/cancelQuestion', params);
    },
    getWithdrawList(params: GetWithdrawListParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/getWithdrawList', params);
    },
    getDownLoadDetail(params: {id: string}): void {
        const url = new URL('/gpbusiness/baidu/getDownLoadDetail', window.location.href);
        url.search = (new URLSearchParams(params)).toString();
        window.location.href = url.toString();
    },
    getWithdrawDetail(params: GetWithdrawDetailParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/getWithdrawDetail', params);
    },
    getWithdrawDetailList(params: any): Promise<any> {
        return axios.post('/gpbusiness/baidu/getWithdrawDetailList', params);
    },
    getBill(params: GetBillParams): Promise<any> {
        return axios.post('/gpbusiness/invoice/getBill', params);
    },
    getcancelbills(params: GetCancelBillsParams): Promise<any> {
        return axios.post('/gpbusiness/baidu/getcancelbills', params);
    },
    getCheckBill(params: {id: string, billIds: any[]}): Promise<any> {
        return axios.post('/gpbusiness/invoice/getCheckBill', params);
    },
    getAccountBalance(): Promise<any> {
        return axios.post('/gpbusiness/baidu/getAccountBalance');
    },
    uploadBill(params: {id: string, bill: string}): Promise<any> {
        return axios.post('/gpbusiness/bill/upload', params);
    },
    checkInvoiceStatus(params: {invoiceNumber: string, invoiceCode: string}): Promise<any> {
        return axios.post('/gpbusiness/invoice/checkStatus', params);
    }
};

export interface GetBillListParams {
    appId?: string
    startDate?: string
    endDate?: string
    status?: string[]
    page: number
    size: number
}

interface SetConfirmParams {
    ids: any[],
    isAll: number
}

interface DownloadBill {
    appId?: string
    startDate?: string
    endDate?: string
    status?: string[]
}

interface GetBanlanceMoney {
    isCanWithdraw: number,
    accountBalance: number
}

interface Invoice {
    invoiceCode: string
    date: string
    noTaxPrice: number
    taxPrice: number
}
export interface GetBiDetailParams {
    id: string
}
export interface SetQuestionParams {
    id: string,
    reason: string,
    money: number | string
};

export interface GetWithdrawListParams {
    startDate: string,
    endDate: string,
    status: number[],
    page: number,
    size: number
}

export interface GetCancelBillsParams {
    id: string
}

interface SetInvoiceParams {
    id: string
    invoiceList: Invoice[]
}

interface GetWithdrawDetailParams {
    withdrawId: string
}

interface GetBillParams {
    invoiceId: string | undefined
}

interface CancelQuestionParams {
    id: string;
}

export default baiduApi;